export const isWindows10 = (): boolean =>
  window.navigator.userAgent.indexOf("Windows NT 10.0") !== -1;
